import * as React from "react";
const SvgFiRrParachuteBox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-parachute-box_svg__a)">
      <path
        fill="#062147"
        d="M23.931 8.842C22.964 3.719 17.945 0 12 0S1.036 3.719.069 8.842a4 4 0 0 0 1.145 3.609l6.022 5.787a3.5 3.5 0 0 0-.235 1.262v1c0 1.93 1.57 3.5 3.5 3.5h3c1.93 0 3.5-1.57 3.5-3.5v-1c0-.445-.084-.87-.235-1.262l6.028-5.793a4 4 0 0 0 1.138-3.604zm-2.633-1.617A3.8 3.8 0 0 0 20 7c-1.193 0-2.304.506-3.149 1.045-.385-2.499-1.449-4.462-2.412-5.796 3.087.644 5.628 2.487 6.859 4.976M12.669 16h-1.338L9.12 10.324C9.774 9.771 10.923 9 11.999 9s2.227.772 2.88 1.323zM9.226 7.819C9.77 5.219 11.17 3.342 12 2.417c.83.926 2.23 2.803 2.774 5.402C13.987 7.373 13.024 7 12 7s-1.987.373-2.774.819m.335-5.57c-.963 1.334-2.027 3.297-2.412 5.796C6.304 7.506 5.192 7 4 7c-.481 0-.913.085-1.298.225 1.231-2.489 3.773-4.332 6.859-4.976m-7.445 7.998c.321-.526.933-1.248 1.884-1.248 1.161 0 2.407.897 3.023 1.448l2.249 5.775a3.5 3.5 0 0 0-.802.428l-5.863-5.635a2 2 0 0 1-.491-.768M15 20.499c0 .827-.673 1.5-1.5 1.5h-3c-.827 0-1.5-.673-1.5-1.5v-1c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5zm.53-3.849a3.5 3.5 0 0 0-.802-.428l2.249-5.775c.617-.553 1.862-1.448 3.023-1.448.951 0 1.564.722 1.885 1.249a2 2 0 0 1-.485.761l-5.869 5.641z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-parachute-box_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrParachuteBox;
